import React, {useEffect, useState} from "react";
import {Autocomplete, Card, CardContent, CircularProgress, Grid, InputAdornment, TextField} from "@mui/material";
import {Controller, useFormContext} from "react-hook-form";
import {PhoneField} from "~/apps/core/ui/PhoneField";
import {Values} from "./PassForm";
import {useAdmissionEmployeeList} from "~/apps/packages/passes/hooks";
import {ArrayElement} from "~/types";
import moment from "moment";
import {useDebounce} from "@react-hook/debounce";

export type PersonalFormCardProps = {}

export const PersonalFormCard = (props: PersonalFormCardProps) => {
    const {control, watch, setValue, errors} = useFormContext<Values>();
    const fullName = watch("fullName");
    const [query, setQuery] = useDebounce(fullName, 180, false);
    const {data: employees} = useAdmissionEmployeeList({
        query: query
    });
    const [selectedEmployee, setSelectedEmployee] = useState<ArrayElement<ReturnType<typeof useAdmissionEmployeeList>["data"]>>(null);

    // load suggestions
    useEffect(() => {
        setQuery(fullName);
    }, [fullName])

    // update data from suggestion
    useEffect(() => {
        if (selectedEmployee) {
            const newValues: Partial<Values> = {
                fullName: selectedEmployee.fullName,
                position: selectedEmployee.position,
                phone: selectedEmployee.phone,
                email: selectedEmployee.email,
                birthDate: selectedEmployee.birthDate ? moment(selectedEmployee.birthDate, "YYYY-MM-DD").toDate() : null,
                birthPlace: selectedEmployee.birthPlace,
                passportSeries: selectedEmployee.passportSeries,
                passportNumber: selectedEmployee.passportNumber,
                passportDate: selectedEmployee.passportDate ? moment(selectedEmployee.passportDate, "YYYY-MM-DD").toDate() : null,
                passportIssuer: selectedEmployee.passportIssuer,
                registrationAddress: selectedEmployee.registrationAddress,
                actualAddress: selectedEmployee.actualAddress,
            }
            for (const [fieldName, value] of Object.entries(newValues)) {
                setValue(fieldName as keyof typeof newValues, value, {shouldValidate: true});
            }
        }
    }, [selectedEmployee, setValue])

    return (
        <Card>
            <CardContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Controller
                            name="fullName"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, ref, name}) => (
                                <Autocomplete
                                    freeSolo
                                    // @ts-ignore
                                    value={selectedEmployee}
                                    inputValue={value}
                                    onInputChange={(e, value) => {
                                        onChange(value.replace(/\d+/g, ''));
                                    }}
                                    onChange={(e, value) => {
                                        setSelectedEmployee(value as any);
                                    }}
                                    // @ts-ignore
                                    getOptionLabel={option => option.fullName}
                                    isOptionEqualToValue={(option, value) => option.fullName == value?.fullName}
                                    disableClearable
                                    renderInput={props => (
                                        <TextField
                                            {...props}
                                            label="ФИО"
                                            placeholder="Иванов Иван Иванович"
                                            error={Boolean(errors?.[name])}
                                            helperText={errors?.[name]?.message}
                                            inputRef={ref}
                                        />
                                    )}
                                    fullWidth
                                    options={employees || []}
                                    filterOptions={options => options}
                                    blurOnSelect
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="position"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Должность"
                                    placeholder="Экспедитор"
                                    fullWidth
                                    inputProps={{maxLength: 128}}
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="phone"
                            control={control}
                            rules={{required: "Обязательно для заполнения", minLength: 10}}
                            render={({onChange, value, name, ref}) => (
                                <PhoneField
                                    label="Телефон"
                                    fullWidth
                                    value={value}
                                    onChange={onChange}
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Controller
                            name="email"
                            control={control}
                            rules={{required: "Обязательно для заполнения"}}
                            render={({onChange, value, name, ref}) => (
                                <TextField
                                    label="Электронная почта"
                                    placeholder="ivanov@mail.ru"
                                    fullWidth
                                    inputProps={{maxLength: 128}}
                                    value={value}
                                    onChange={onChange}
                                    type="email"
                                    error={Boolean(errors?.[name])}
                                    helperText={errors?.[name]?.message}
                                    inputRef={ref}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
